import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import {
  AllVehicleIssueResponseModel,
  CommonResponseModel,
  departmentIdReq,
  driverIdReq,
  VehicleIssueStatusenum,
} from "@project-management-system/shared-models";
import { VehicleissueEntity } from "./vehicle-issue-entity";
import { VehicleIssueDto } from "./vehicle-issue-dto";
import { FileUploadEntity } from "./file-upload-entity";
import * as fs from "fs";

@Injectable()
export class VehicleIssueService {
  constructor(
    @InjectRepository(VehicleissueEntity)
    private vehiclesRepository: Repository<VehicleissueEntity>,
    @InjectRepository(FileUploadEntity)
    private fileuploadRepo: Repository<FileUploadEntity>
  ) { }

  async createVehicleIssue(
    data: VehicleIssueDto,
    isUpdate: boolean
  ): Promise<AllVehicleIssueResponseModel> {
    try {
      const vehicle = new VehicleissueEntity();
      vehicle.vehicleId = data.vehicleId;
      vehicle.employeeId = data.employeeId;
      vehicle.title = data.title;
      vehicle.plantId = data.plantId;
      vehicle.description = data.description;
      vehicle.fileUpload = data.fileUpload;
      vehicle.priority = data.priority;
      vehicle.dueDate = data.dueDate;
      vehicle.vehicleStatus = data.vehicleStatus;
      if (isUpdate) {
        vehicle.id = data.id;
        vehicle.updatedUser = data.updatedUser;
      } else {
        vehicle.createdUser = data.createdUser;
      }
      const save = await this.vehiclesRepository.save(vehicle);
      if (save) {
        return new AllVehicleIssueResponseModel(
          true,
          0,
          isUpdate
            ? "Vehicle Issue Updated Successfully"
            : "Vehicle Issue Created Successfully"
        );
      }
    } catch (error) {
      throw error;
    }
  }

  async getEmployee(): Promise<CommonResponseModel> {
    const query = `
    SELECT e.id ,e.employee_name AS employeeName  FROM employee e`;
    const result = await this.vehiclesRepository.query(query);
    if (result) {
      return new CommonResponseModel(true, 1, "Data Retrived", result);
    } else {
      return new CommonResponseModel(false, 0, "Data Retrived");
    }
  }

  async vehicleIssuefileUpload(
    filesData: any[],
    createdUser: string,
    id: number
  ): Promise<FileUploadEntity[]> {
    try {
      const fileEntities: FileUploadEntity[] = [];
      filesData.forEach((file, index) => {
        const fileObj = new FileUploadEntity();
        const fileEntityKeys = Object.keys(file);
        Object.keys(file).forEach((key) => {
          if (fileEntityKeys.includes(key)) {
            fileObj[key] = file[key];
          }
        });
        fileObj.vehicleIssueId = id;
        fileObj.fileName = file.filename;
        fileObj.originalfileName = file.originalname;
        fileObj.filePath = file.path;
        fileObj.createdUser = createdUser;
        fileObj.id = file.fileUploadId;
        fileEntities.push(fileObj);
      });
      const save = await this.fileuploadRepo.save(fileEntities);
      return save;
    } catch (error) {
      for (const file of filesData) {
        const filesDestination = "./files";
        const filePath = `${filesDestination}/${file.uid}.${file.name.substring(
          file.name.lastIndexOf(".") + 1
        )}`;
        if (fs.existsSync) {
          fs.unlinkSync(filePath);
        }
      }
    }
  }

  async getVehicle(): Promise<CommonResponseModel> {
    const query = `
    SELECT v.id ,v.vehicle_name AS vehicleName  FROM vehicle v`;
    const result = await this.vehiclesRepository.query(query);
    if (result) {
      return new CommonResponseModel(true, 1, "Data Retrived", result);
    } else {
      return new CommonResponseModel(false, 0, "Data Retrived");
    }
  }

  async getAllVehicleissue(req: driverIdReq): Promise<CommonResponseModel> {

    let query = `
   
SELECT vi.id,vi.employee_id AS employeeId,vi.title,vi.description,vi.priority,
vi.vehicle_id as vehicleId,vi.file_upload AS fileUpload,vi.due_date AS dueDate, vi.Vehicle_Status AS vehicleStatus,
e.employee_name AS employeeName,v.vehicle_name AS vehicleName,p.plant_id AS plantId,p.plant_name AS plantName
FROM vehicle_issue vi
LEFT JOIN employee e ON e.id = vi.employee_id
LEFT JOIN vehicle v O N v.id=vi.vehicle_id
LEFT JOIN plants p ON p.plant_id=vi.plant_id
 where vi.id >0`;


      if(req.plant){
        query +=` and p.plant_name= '${req.plant}'`
    }
    

    const result = await this.vehiclesRepository.query(query);
    if (result) {
      return new CommonResponseModel(true, 1, "Data Retrived", result);
    } else {
      return new CommonResponseModel(false, 0, "No Data", []);
    }
  }

  async getVehicleIssueDashBoard(): Promise<CommonResponseModel> {
    const vehicleIssueStatusValues = Object.values(VehicleIssueStatusenum)
      .map(status => `'${status}'`)
      .join(', ');
      // console.log(Object.values(VehicleIssueStatusenum))
      let data:any[] = [];
    for(const res of Object.values(VehicleIssueStatusenum)){
      // console.log(res);
      const query = `
      SELECT COUNT(vi.id) AS openCount, '`+res+`' AS status
      FROM vehicle_issue vi
      WHERE Vehicle_Status = '`+res+`'`
      const result = await this.vehiclesRepository.query(query);
      data.push(result);
    }
    if (data) {
      return new CommonResponseModel(true, 1, "Data Retrived", data);
    } else {
      return new CommonResponseModel(false, 0, "Data Retrived");
    }
  }
}
